@use "variables" as *;

.item {
  aspect-ratio: 3 / 1.44;
  display: flex;
}

.skeleton {
  width: 100%;
  height: 100% !important;
  border-radius: 8px;
  min-width: 164px;
}
